import axios from "axios";
import { useState } from "react";

import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";

// `itens` + `modulo` (opcionais): quando a tela tem o carrinho, manda pro servidor
// decidir quais itens entram na conta do cupom (produto em promoção que não aceita
// cupom fica fora — achados 411 e 412). Sem os itens, vale o subtotal inteiro.
// O `modulo` vai sempre que a tela informa: o cupom só é aceito nos módulos
// marcados nele ("Onde vale").
export default function CupomForm({ subtotal, clienteId, clienteTelefone, itens, modulo, onAplicar, onVoltar }) {
  const [codigo, setCodigo] = useState("");
  const [validando, setValidando] = useState(false);
  const [erro, setErro] = useState("");

  const validar = async () => {
    const code = codigo.trim().toUpperCase();
    setValidando(true);
    setErro("");
    try {
      const { data } = await axios.post("/api/coupons/validate", {
        code,
        order_total: subtotal,
        customer_id: clienteId || null,
        customer_phone: clienteTelefone || null,
        ...(modulo ? { modulo } : {}),
        ...(itens?.length ? { items: itens } : {}),
      });
      if (!data?.valid) {
        setErro(data?.message || data?.error || "Cupom inválido.");
        return;
      }
      onAplicar({ ...data, code: data.code || code });
    } catch (err) {
      setErro(err.response?.data?.detail || "Erro ao validar cupom.");
    } finally {
      setValidando(false);
    }
  };

  return (
    <>
      <Input
        value={codigo}
        onChange={(e) => { setCodigo(e.target.value.toUpperCase()); setErro(""); }}
        onFocus={(e) => e.target.select()}
        placeholder="CÓDIGO DO CUPOM"
        className="h-10 text-sm uppercase tracking-wider font-bold text-center"
        autoFocus
      />
      {erro && <p className="text-[10px] text-red-500">{erro}</p>}
      <div className="flex gap-1.5">
        <Button variant="outline" size="sm" className="flex-1 h-8 text-[11px]" onClick={onVoltar}>Voltar</Button>
        <Button size="sm" className="flex-1 h-8 text-[11px] bg-orange-500 hover:bg-orange-600" disabled={!codigo.trim() || validando} onClick={validar}>
          {validando ? "..." : "Aplicar"}
        </Button>
      </div>
    </>
  );
}
